var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',[_c('v-app-bar',{attrs:{"app":"","dark":"","color":"pink"}},[_c('v-toolbar-title',{staticClass:"headline text-uppercase"},[_vm._v("YodaCloud Consult")]),_c('v-spacer'),_c('y-auth-button',{attrs:{"success-color":"yellow accent-2","error-color":"deep-orange"}})],1),_c('v-main',[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }